import React, { useCallback } from "react";
import { Box, Button, DialogActions, DialogContent, DialogTitle, Divider, FormLabel } from "@mui/material";
import { useSalesareaCtx } from "../../../old/beheer/views/Upsell/modernTS/salesarea/SalesareaContext";
import { useCreateSalesAreaPriceLineMutation } from "../api/priceLineApi";
import { HookTextField, useHookForm } from "mui-react-hook-form-plus";
import { toast } from "react-toastify";
import { BlockUserInput } from "@jamezz/react-components";

export type SalesAreaPriceLineForm = {
  title: string;
};
export function CreateSalesAreaPriceLineDialog({
  onCancel,
  onCreate,
}: {
  onCancel: () => void;
  onCreate?: () => void;
}) {
  const hookForm = useHookForm<SalesAreaPriceLineForm>({
    defaultValues: {
      title: "",
    },
    reValidateMode: "onChange",
  });
  const { registerState, handleSubmit, getValues, formState } = hookForm;
  const { id: salesarea_id } = useSalesareaCtx();

  const [createSalesAreaPriceLine] = useCreateSalesAreaPriceLineMutation();
  const createPriceLine = BlockUserInput.useWrapPromise(createSalesAreaPriceLine);

  const onSubmit = useCallback(() => {
    hookForm.trigger().then((result) => {
      if (result) {
        createPriceLine({ sales_area_id: salesarea_id, sales_area_price_line: getValues() }).then((result) => {
          if (result.error) {
            toast.error((result.error as any).data.message);
          } else {
            onCreate?.();
          }
        });
      }
    });
  }, [createPriceLine, getValues, hookForm, onCreate, salesarea_id]);
  return (
    <Box>
      <DialogTitle>Create a new price line</DialogTitle>
      <Divider sx={{ mb: 2 }} />
      <DialogContent>
        <Box sx={{ display: "grid", gap: 1 }}>
          <FormLabel>Name your price line (e.g. Price line 1)</FormLabel>
          <HookTextField
            textFieldProps={{
              variant: "filled",
              label: "Name",
              helperText: "This name is shown in the backoffice, not to customers",
              autoFocus: true,
            }}
            {...registerState("title")}
            rules={{
              required: true,
            }}
          />
        </Box>
      </DialogContent>
      <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
        <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button onClick={onCancel}>Cancel</Button>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Button color={"success"} onClick={onSubmit} type={"submit"} variant={"contained"}>
              Create price line
            </Button>
          </Box>
        </DialogActions>
      </Box>
    </Box>
  );
}
